export function setCaret(node, offset) {
    const selection = window.getSelection()
    if (!selection) return
    const range = document.createRange()
    range.setStart(node, offset)
    range.collapse(true)
    selection.removeAllRanges()
    selection.addRange(range)
}

export function getCursorIndexFromRange(element, range) {
    if (!element || !range) return 0
    const preRange = range.cloneRange()
    preRange.selectNodeContents(element)
    preRange.setEnd(range.startContainer, range.startOffset)
    return preRange.cloneContents().textContent?.length ?? 0
}

export function resolveSelectionRect() {
    const selection = window.getSelection()
    if (!selection || selection.rangeCount === 0) return null
    const range = selection.getRangeAt(0)
    const rect = range.getBoundingClientRect()
    if (rect && rect.width + rect.height > 0) return rect
    const rects = range.getClientRects()
    if (rects && rects.length > 0) return rects[0]
    return null
}
